<template>
  <icon class="svg-icon">
    <use :xlink:href="symbolId" fill="currentColor" />
  </icon>
</template>

<script>
import iconIds from 'virtual:svg-icons-names'
import { defineComponent, computed } from 'vue'
import Icon from '@ant-design/icons-vue'
export default defineComponent({
  name: 'SvgIcon',
  props: {
    prefix: {
      type: String,
      default: 'icon'
    },
    dir: {
      type: String,
      default: 'menu'
    },
    name: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: '#333'
    }
  },
  components: {
    Icon
  },
  setup(props) {
    const symbolId = computed(() => {
      let id = `#${props.prefix}-${props.dir}-${props.name}`
      // 找不到对应注册的svgID就给个默认值
      if (!iconIds.find((d) => `#${d}` === id)) {
        id = `#${props.prefix}-${props.dir}-account`
      }
      return id
    })
    return { symbolId }
  }
})
</script>
